import * as React from 'react';
import PropTypes from 'prop-types';
var SvgAchievementsTrophyNormalSmall = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22 3h-2V2a1 1 0 00-1-1H5a1 1 0 00-1 1v1H2a1 1 0 00-1 1v3c0 2.093 1.43 4 3 4 .045-.006.09-.015.134-.027.624 3.465 3.46 5.819 7.366 6.006V19h-3a1 1 0 00-.894.553l-1 2A1 1 0 007.5 23h9a1 1 0 00.894-1.447l-1-2A1 1 0 0015.5 19h-3v-2.021c3.906-.187 6.742-2.541 7.366-6.006.044.012.089.021.134.027 1.57 0 3-1.907 3-4V4a1 1 0 00-1-1zm-6.5 17l1 2h-9l1-2h7zM4 10c-1 0-2-1.461-2-3V4h2v6zm8 6c-4.163 0-7-2.636-7-6.5V2h14v7.5c0 3.864-2.837 6.5-7 6.5zm10-9c0 1.539-1 3-2 3V4h2v3z"
  }));
});
SvgAchievementsTrophyNormalSmall.defaultProps = {
  height: 24,
  width: 24
};
SvgAchievementsTrophyNormalSmall.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};
export default SvgAchievementsTrophyNormalSmall;